<template>
  <div class="wrap">
    <div class="wrapNav">
      <p class="wrapNavTitle">ISC大会介绍</p>
      <p class="wrapNavDesc">INTERNET SECURITY CONFERENCE</p>
      <div class="wrapNavList">
        <img :src="nav.pic" alt="内容宣传图" class="wrapNavListImg" />
        <div class="wrapNavListNav">
          <p class="wrapNavListNavTitle">{{ nav.title }}</p>
          <p class="wrapNavListNavTitleS">{{ nav.title_small }}</p>
          <div class="wrapNavListNavDesc">
            {{ nav.desc }}
          </div>
          <Btn :navArr="IscAbout_2023" :style="styleBtn" @fetchNav="fetchNav" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { IscAbout_2023 } from '@/mock/2023isc/data.js'
import { ref } from 'vue'
import Btn from '@/components/common/2023/button.vue'
const styleBtn = {
  position: 'absolute',
  top: '14px',
  right: '8px'
}
const nav = ref(IscAbout_2023[0])
function fetchNav(newId) {
  nav.value = IscAbout_2023[newId]
}
</script>

<style lang="scss" scoped>
.clear {
  margin: 0;
}
.wrap {
  width: 100%;
  // min-width: 390px;
  background: #f7f8fc;
  overflow: hidden;
  padding-bottom: 13px;
  &Nav {
    width: 100%;
    margin: 16px auto 0;
    background: url('https://p2.ssl.qhimg.com/t01771b149917a34d61.png') no-repeat;
    background-size: contain;
    text-align: center;
    &Title {
      font-size: 18px;
      line-height: 28px;
      color: #00ab7a;
      font-weight: bold;
      margin: 0;
    }
    &Desc {
      font-size: 12px;
      line-height: 20px;
      color: #3d3d3d;
      margin: 4px 0 16px;
    }
    &List {
      position: relative;
      background: #ffffff;
      &Img {
        display: block;
        width: 100vw;
        // width: 390px;
        // height: 218px;
      }
      &Nav {
        position: relative;
        padding: 16px;
        text-align: left;
        &Title {
          font-size: 16px;
          font-weight: bold;
          line-height: 16px;
        }
        &TitleS {
          font-size: 14px;
          line-height: 14px;
          color: #666666;
          margin: 14px 0 18px;
        }

        &Desc {
          font-size: 16px;
          line-height: 32px;
          color: #3d3d3d;
        }
      }
    }
  }
}
</style>
